import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_Map = _resolveComponent("Map")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CosInput, {
      value: _ctx.addressModal,
      placeholder: "请选择",
      view: _ctx.view,
      allowClear: true,
      onClick: _ctx.showModal,
      onChange: _ctx.handleChange
    }, {
      enterButton: _withCtx(() => [
        _createVNode(_component_a_button, null, {
          default: _withCtx(() => [
            _createTextVNode("Custom")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "view", "onClick", "onChange"]),
    _createVNode(_component_cos_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
      title: "地址选择",
      width: "90%",
      height: "80%",
      onOk: _ctx.handleOk,
      maskClosable: false
    }, {
      default: _withCtx(() => [
        (_ctx.visible)
          ? (_openBlock(), _createBlock(_component_Map, {
              key: 0,
              onMapData: _ctx.mapData,
              editData: {
          geoPoint: _ctx.geoPoint,
          address: _ctx.address
        }
            }, null, 8, ["onMapData", "editData"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ]))
}